import React from 'react';
import { helperTexts } from '../../util/helperTexts';
import useFetchCRDetails from './hooks/useFetchCRDetails';
import CRDetailCard from './components/CRDetailCard';
import { Button, Card, Tooltip } from '@sede-enterprise/shell-ds-react-framework';
import { InfoCircle } from '@sede-enterprise/shell-ds-react-framework/build/esm/components/Icon/components';
import { mmOrInch } from '../../util/helperFunctions';
import useFetchWtloss from './hooks/useFetchWtloss';
const TO_INCHES = 0.0394;

const helpContents = helperTexts.sensorCrDetails;

const SensorCRDetails = (props) => {
    const { units, sensorID, start, end } = props;
    const { CRDetailsData } = useFetchCRDetails(sensorID, start, end);
    const { WTLossData, error } = useFetchWtloss(sensorID, start, end);

    return (
        <div className="cr-details-container" id="sensor-cr-details-id-1">
            <CRDetailCard
                label="Long Term CR"
                tooltipContent={helpContents.longCR}
                value={CRDetailsData?.longTermCR}
                units={units}
                idPrefix="sensor-cr-details-long-term"
            />
            <CRDetailCard
                label="Short Term CR"
                tooltipContent={helpContents.shortCR}
                value={CRDetailsData?.shortTermCR}
                units={units}
                idPrefix="sensor-cr-details-short-term"
            />
            <CRDetailCard
                label="Real Time CR"
                tooltipContent={helpContents.realCR}
                value={CRDetailsData?.realTimeCR}
                units={units}
                idPrefix="sensor-cr-details-real-time"
            />
            <CRDetailCard
                label="Custom CR"
                tooltipContent={helpContents.customCR}
                value={CRDetailsData?.customCR}
                units={units}
                idPrefix="sensor-cr-details-custom"
            />
            <Card className="cr-details-card" bodyPadding={false} id='sensor-cr-details-wtloss-card'>
                <div className="cr-details-info" id='sensor-cr-details-wtloss-info'>
                    <div className="label-container" id='sensor-cr-details-wtloss-label-container'>
                        <p className="data-label" id='wt-loss-label' >WT Loss</p>
                        <Tooltip
                            id="sensor-cr-details-wtloss-tooltip"
                            placement="bottom"
                            className="tooltip"
                            overlay={<div id='wt-loss-tooltip-content' className="tooltip-content">{helpContents.wtLoss}</div>}
                            trigger={
                                <Button
                                    id="sensor-cr-details-wtloss-button"
                                    size="xsmall"
                                    variant="transparent"
                                    iconOnly
                                    icon={<InfoCircle id='wt-loss-info-icon' />}
                                />
                            }
                        />
                    </div>
                    <p className="data-value" id='wt-loss-value'>
                        {error ? <>NA</> : <>{units ? (WTLossData?.wtloss * TO_INCHES)?.toFixed(3) : WTLossData?.wtloss?.toFixed(3)} {mmOrInch(units)}</>}
                    </p>
                    {!error && WTLossData?.start && WTLossData?.end && (
                        <p className="data-value-subtext data-label" id='wt-loss-subtext'>
                            {` (${WTLossData?.start} - ${WTLossData?.end})`}
                        </p>
                    )}
                    {error && (
                        <p className="data-value-subtext data-label redContent" id='wt-loss-error'>
                            {error}
                        </p>
                    )}
                </div>
            </Card>
        </div>
    );
};

export default SensorCRDetails;